import * as yup from 'yup';
import { validationErrors } from 'src/utils/validation/validationErrors';
import { EMAIL } from 'src/utils/validation/validationRules';

export const forgotPasswordValidationSchema = yup.object().shape({
  email: EMAIL.required(validationErrors.REQUIRED_FIELD),
});
